@if (items?.length > 1) {
  <p class="item-amount">
    {{ 'FRONTEND.STORE.CONTAINS_NUM_ITEMS' | translate : { itemCount: items.length } }}
  </p>
}
<div class="wrapper">
  @if (items && !hideItemsNav) {
    <nav (swipeleft)="pageNext(slides)" (swiperight)="pagePrev(slides)">
      <div [ngClass]="{ 'hide-arrows': items && items.length < 5 }">
        <span class="prev" (click)="pagePrev(slides)">
          <mat-icon>keyboard_arrow_left</mat-icon>
        </span>
        <span class="next" (click)="pageNext(slides)">
          <mat-icon>keyboard_arrow_right</mat-icon>
        </span>
      </div>
      <ul class="slides" #slides>
        @for (lineItem of items; track lineItem) {
          <li (click)="onItemSelected($safeNavigationMigration(lineItem?.item?.id))">
            <a [ngClass]="{ active: lineItem?.item?.id === selected_id }">
              <span class="icon-area">
                <va-icon [iconUrl]="$safeNavigationMigration(lineItem?.item?.icon)" [iconName]="$safeNavigationMigration(lineItem?.item?.name)" [diameter]="80"></va-icon>
                @if (lineItem?.parent?.id) {
                  <va-icon
                    class="addon-indicator"
                    [iconUrl]="$safeNavigationMigration(lineItem?.parent?.icon)"
                    [iconName]="$safeNavigationMigration(lineItem?.parent?.name)"
                    [diameter]="24"
                  ></va-icon>
                }
              </span>
              <div class="name-container">
                <div>{{ lineItem?.item?.name }}</div>
                @if (lineItem?.item?.editionName) {
                  <div class="edition-name">
                    {{ lineItem.item.editionName }}
                  </div>
                }
              </div>
              @if (lineItem?.parent?.id) {
                <div>
                  <span class="requires-text">
                    {{ 'FRONTEND.STORE.REQUIRES' | translate }}
                  </span>
                  <span>{{ lineItem?.parent.name }}</span>
                </div>
              }
            </a>
          </li>
        }
      </ul>
    </nav>
  }
</div>
